import { Box } from '@betterment/samba-react';
import { SystemStyleObject } from '@betterment/samba-styled-system/types';
import { Notifications as SharedNotifications } from '@betterment/shared-components';

type Props = {
  css?: SystemStyleObject;
};

export function Notifications({ css: cssProp }: Props) {
  return (
    <Box
      css={{
        bg: 'background.surface',
        display: 'grid',
        gridTemplateColumns: 'auto minmax(min-content, 1200px) auto',
        sm: { gridColumnGap: 'space.0' },
        md: { gridColumnGap: 'space.400' },
        ...cssProp,
      }}
    >
      <SharedNotifications
        css={{
          gridColumnStart: 2,
        }}
      />
    </Box>
  );
}
